<template>
  <div class="container">
    <div class="col-lg-4 col-md-6 ml-auto mr-auto">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(submit)">
          <card class="card-login card-white">
            <template slot="header">
              <img src="img/logo-ki-web.jpg" alt="" />
              <h1
                class="card-title"
                style="padding-left: 5px; visibility: hidden"
              >
                LOGIN <br />
              </h1>
              <br />
            </template>

            <div>
              <ValidationProvider
                name="userid"
                rules="required"
                v-slot="{ passed, failed, errors }"
              >
                <base-input
                  style="
                    font-size: 17px !important;
                    background-color: #ffffff !important;
                  "
                  required
                  v-model="userid"
                  placeholder="EMAIL"
                  addon-left-icon="tim-icons icon-single-02"
                  :error="errors[0]"
                  :class="[{ 'has-success': passed }, { 'has-danger': failed }]"
                >
                </base-input>
              </ValidationProvider>
            </div>


            <div slot="footer">
              <base-button
                native-type="submit"
                type="primary"
                class="mb-3"
                size="lg"
                block
                style="
                  color: #313e5e !important;
                  border: 0.2px solid #313e5eb !important;
                "
              >
                KIRIM
              </base-button>
              
            </div>
          </card>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>
<script>
import { extend } from "vee-validate";
import { required, email, min } from "vee-validate/dist/rules";
import api from "./api";
import swal from "sweetalert2";
import auth from "../../util/auth";

extend("email", email);
extend("min", min);

extend("required", required);

export default {
  data() {
    return {
      userid: "",
      subscribe: true,
    };
  },
  methods: {
    submit() {
      api
        .forget(this.userid.toString().trim().toUpperCase())
        .then((userapp) => {
          if (userapp.data.length > 0) {
            var msg = `Password anda telah dikirim, Silahkan Check Email Anda "${userapp.data[0].EMAIL}"`;
            swal.fire({
              title: "Forget Password",
              text: msg,
              icon: "info",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false,
            }).then(()=>{
              this.$router.push({ path: "/login" });
            });
          } else {
            var errLogin = "EMAIL Anda Belum Terdaftar"
            swal.fire({
              title: "Forget Password",
              text: errLogin,
              icon: "error",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false,
            });
          }
        });
    },
  },
  mounted() {
    
  },
};
</script>
<style>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}
input.form-control {
  font-size: 17px !important;
}
</style>
